import React, { useEffect, useState } from "react";
import { Row, Col, Input, Button, Table } from "reactstrap";
import api from "../../../../api";

const EcnAssociatedDocsTab = ({ data, setData }) => {

    const [availableDocs, setAvailableDocs] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [selectedAvailableId, setSelectedAvailableId] = useState(null);
    const [selectedAssociatedId, setSelectedAssociatedId] = useState(null);
    const [searching, setSearching] = useState(false);

    const loadDocuments = async (text) => {
        try {
            setSearching(true);
            const response = await api.get(
                `/dms/associated-documents?page=1&pageSize=50&search=${text ?? ""}`
            );
            setAvailableDocs(response.data.data || []);
        } catch (err) {
            console.error("Error loading documents", err);
        } finally {
            setSearching(false);
        }
    };

    // ✅ Debounce — fires 400ms after user stops typing
    useEffect(() => {
        const timer = setTimeout(() => {
            loadDocuments(searchText);
        }, 400);
        return () => clearTimeout(timer);
    }, [searchText]);

    const addSelectedDocument = () => {
        if (!selectedAvailableId) return;
        const doc = availableDocs.find(d => d.dmsid === selectedAvailableId);
        if (!doc) return;
        if (!data.some(d => d.dmsid === doc.dmsid)) {
            setData([...data, doc]);
        }
        setSelectedAvailableId(null);
    };

    const removeSelectedDocument = () => {
        if (!selectedAssociatedId) return;
        setData(data.filter(d => d.dmsid !== selectedAssociatedId));
        setSelectedAssociatedId(null);
    };

    return (
        <>
            <h6>Associated Documents</h6>

            {/* Top Grid - Selected Docs */}
            <div className="border p-3 mb-3">
                <Table bordered hover size="sm">
                    <thead className="table-light">
                        <tr>
                            <th>Document ID</th>
                            <th>Rev</th>
                            <th>Title</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="text-center text-muted py-3">
                                    No associated documents.
                                </td>
                            </tr>
                        ) : (
                            data.map(doc => (
                                <tr
                                    key={doc.dmsid}
                                    onClick={() => setSelectedAssociatedId(doc.dmsid)}
                                    style={{
                                        backgroundColor: selectedAssociatedId === doc.dmsid ? "#d9edf7" : "",
                                        cursor: "pointer"
                                    }}
                                >
                                    <td>{doc.docId}</td>
                                    <td>{doc.rev}</td>
                                    <td>{doc.docTitle}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>

                <div className="text-end">
                    <Button
                        color="danger"
                        size="sm"
                        disabled={!selectedAssociatedId}
                        onClick={removeSelectedDocument}
                    >
                        <i className="ri-delete-bin-line me-1" />
                        Remove Selected
                    </Button>
                </div>
            </div>

            {/* Bottom Grid - Search & Add */}
            <h6>Add New Associated Document</h6>

            {/* ✅ No Search button — just type to search */}
            <div className="mb-3 position-relative">
                <div className="search-box">
                    <Input
                        placeholder="Type to search by Doc ID or Title..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                    <i className="ri-search-line search-icon" />
                </div>
                {searching && (
                    <span
                        className="position-absolute top-50 translate-middle-y text-muted"
                        style={{ right: 12, fontSize: 12 }}
                    >
                        <span className="spinner-border spinner-border-sm me-1" />
                        Searching...
                    </span>
                )}
            </div>

            <div className="border rounded" style={{ maxHeight: "220px", overflowY: "auto" }}>
                <Table bordered hover size="sm" className="mb-0">
                    <thead className="table-light sticky-top">
                        <tr>
                            <th>Doc ID</th>
                            <th>Title</th>
                            <th>Rev</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {searching ? (
                            <tr>
                                <td colSpan="4" className="text-center text-muted py-3">
                                    <span className="spinner-border spinner-border-sm me-2" />
                                    Loading...
                                </td>
                            </tr>
                        ) : availableDocs.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="text-center text-muted py-3">
                                    No documents found.
                                </td>
                            </tr>
                        ) : (
                            availableDocs.map(doc => (
                                <tr
                                    key={doc.dmsid}
                                    onClick={() => setSelectedAvailableId(doc.dmsid)}
                                    style={{
                                        backgroundColor: selectedAvailableId === doc.dmsid ? "#d9edf7" : "",
                                        cursor: "pointer"
                                    }}
                                >
                                    <td>{doc.docId}</td>
                                    <td>{doc.docTitle}</td>
                                    <td>{doc.rev}</td>
                                    <td>{doc.status}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>

            <div className="text-end mt-3">
                <Button
                    color="success"
                    size="sm"
                    disabled={!selectedAvailableId}
                    onClick={addSelectedDocument}
                >
                    <i className="ri-add-line me-1" />
                    Add Selected Document
                </Button>
            </div>
        </>
    );
};

export default EcnAssociatedDocsTab;